<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title class="text-h5 deep-purple white--text">
        <v-icon left dark>mdi-calendar-plus</v-icon>
        {{ isEdit ? "Edit" : "Schedule" }} Appointment
      </v-card-title>

      <v-card-text class="pt-6">
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="formData.date"
            label="Date"
            type="date"
            :rules="[rules.required]"
            outlined
            dense
          >
            <template v-slot:prepend>
              <v-icon>mdi-calendar</v-icon>
            </template>
          </v-text-field>

          <v-text-field
            v-model="formData.time"
            label="Time"
            type="time"
            :rules="[rules.required]"
            outlined
            dense
          >
            <template v-slot:prepend>
              <v-icon>mdi-clock-outline</v-icon>
            </template>
          </v-text-field>

          <v-select
            v-model="formData.type"
            :items="appointmentTypes"
            label="Appointment Type"
            :rules="[rules.required]"
            outlined
            dense
          ></v-select>

          <v-select
            v-model="formData.status"
            :items="statusOptions"
            label="Status"
            outlined
            dense
          ></v-select>

          <v-textarea
            v-model="formData.notes"
            label="Notes"
            outlined
            dense
            rows="3"
          ></v-textarea>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog"> Cancel </v-btn>
        <v-btn
          color="deep-purple"
          dark
          @click="saveAppointment"
          :disabled="!valid"
        >
          <v-icon left>mdi-content-save</v-icon>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AppointmentDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    appointment: {
      type: Object,
      default: null,
    },
    appointmentTypes: {
      type: Array,
      default: () => [
        "Consultation",
        "Follow-up",
        "Procedure",
        "Check-up",
        "Emergency",
      ],
    },
  },

  data: () => ({
    valid: false,
    formData: {
      date: new Date().toISOString().substr(0, 10),
      time: "",
      type: "",
      notes: "",
      status: "scheduled",
    },
    statusOptions: [
      { text: "Scheduled", value: "scheduled" },
      { text: "Completed", value: "completed" },
      { text: "Cancelled", value: "cancelled" },
      { text: "No Show", value: "no-show" },
    ],
    rules: {
      required: (v) => !!v || "This field is required",
    },
  }),

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    isEdit() {
      return this.appointment !== null;
    },
  },

  watch: {
    value(val) {
      if (val && this.appointment) {
        this.formData = { ...this.appointment };
      } else if (val) {
        this.resetForm();
      }
    },
  },

  methods: {
    saveAppointment() {
      if (this.$refs.form.validate()) {
        this.$emit("save", this.formData);
        this.closeDialog();
      }
    },

    closeDialog() {
      this.$emit("input", false);
      this.$emit("close");
      this.resetForm();
    },

    resetForm() {
      this.formData = {
        date: new Date().toISOString().substr(0, 10),
        time: "",
        type: "",
        notes: "",
        status: "scheduled",
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
